// services/clientService.ts
import axios from "axios";
import { Client, BaseClient } from "../../types/features/support/Client";
import { PaginatedResponse } from "../../types/utils/PaginatedResponse";
import { MAIN_API_URL } from "../../config/api";

export const clientService = {
  // Liste paginée des clients
  async getClients(page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Client>> {
    const response = await axios.get<PaginatedResponse<Client>>(`${MAIN_API_URL}/clients`, {
      params: { page, per_page: perPage },
    });
    return response.data;
  },

  async getClientById(id: string): Promise<Client | null> {
    const response = await axios.get<Client>(`${MAIN_API_URL}/clients/${id}`);
    return response.data;
  },

  async searchClientByPhone(phone: string): Promise<Client | null> {
    const response = await axios.get<Client>(`${MAIN_API_URL}/clients/search/by-phone`, {
      params: { phone },
    });
    return response.data;
  },

  async searchClientByEmail(email: string): Promise<Client | null> {
    const response = await axios.get<Client>(`${MAIN_API_URL}/clients/search/by-email`, {
      params: { email },
    });
    return response.data;
  },

  async searchClients(query: string, page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Client>> {
    const response = await axios.get<PaginatedResponse<Client>>(`${MAIN_API_URL}/clients/search`, {
      params: { q: query, page, per_page: perPage },
    });
    return response.data;
  },

  // Créer un client (prospect ou user existant)
  async createClient(client: Omit<Client, "id" | "created_at" | "updated_at">): Promise<Client> {
    const response = await axios.post<Client>(`${MAIN_API_URL}/clients`, client);
    return response.data;
  },

  // Mettre à jour un client
  async updateClient(id: string, data: Partial<BaseClient>): Promise<Client> {
    const response = await axios.put<Client>(`${MAIN_API_URL}/clients/${id}`, data);
    return response.data;
  },

  // Statistiques des clients
  async getStats(): Promise<ClientStats> {
    const response = await axios.get<ClientStats>(`${MAIN_API_URL}/clients/stats`);
    return response.data;
  },

  // services/support/clientService.ts

  async getClientByUserId(userId: string): Promise<Client | null> {
    try {
      const response = await axios.get<Client>(`${MAIN_API_URL}/clients/by-user/${userId}`);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  // services/support/clientService.ts

  async findOrCreateByUserId(data: {
    user_id: string;
    firstname?: string;
    lastname?: string;
    email?: string;
    phone?: string;
  }): Promise<Client> {
    const response = await axios.post<Client>(`${MAIN_API_URL}/clients/find-or-create-by-user`, data);
    return response.data;
  },
};

export interface ClientStats {
  total: number;
  users: number;
  prospects: number;
}
